export const EVENT_DOCUMENTS_QUERY_KEY = 'eventDocuments' as const;

export const eventDocumentsKeys = {
  byEventNumber: (eventNumber: number) =>
    [EVENT_DOCUMENTS_QUERY_KEY, 'eventNumber', eventNumber] as const
} as const;
